import { User, UserService } from '../api';

interface UsersProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: User[]; total: number }>;
  getOne: (resource: string, params: any) => Promise<{ data: User }>;
  create: (resource: string, params: any) => Promise<{ data: User }>;
  update: (resource: string, params: any) => Promise<{ data: User }>;
  delete: (resource: string, params: any) => Promise<{ data: {} }>;
  getMany: (resource: string, params: any) => Promise<{ data: User[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: User[] }>;
  updateMany: (resource: string, params: any) => Promise<{ data: User[] }>;
  deleteMany: (resource: string, params: any) => Promise<{ data: {} }>;
}

export const usersDataProvider: UsersProviderResource = {
  getList: async (resource, params) => {
    const { items } = await UserService.listUser();
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: items,
      total: items.length,
    };
  },
  getOne: async (resource, params) => {
    const { id } = params;

    const user = await UserService.getUserByName(id);
    return {
      data: user,
    };
  },
  create: async (resource, params) => {
    const user = await UserService.createUser(params.data);
    return {
      data: user,
    };
  },
  update: async (resource, params) => {
    const user = await UserService.updateUser(params.id, params.data);
    return {
      data: user,
    };
  },
  delete: async (resource, params) => {
    const { id } = params;
    await UserService.deleteUser(id);
    return {
      data: {},
    };
  },
  getMany: async (resource, params) => ({
    data: [],
  }),
  getManyReference: async (resource, params) => ({
    data: [],
  }),
  updateMany: async (resource, params) => ({
    data: [],
  }),
  deleteMany: async (resource, params) => {
    const promises = params.ids.map((id: number) => UserService.deleteUser(id));

    await Promise.all(promises);

    return {
      data: {},
    };
  },
};
